import React from "react";
import Page from "../Components/Page";
import { useParams } from "react-router-dom";
import useFetchData from "../hooks/useFetchData";
import { IScene } from "../features/scenes/types";
import SceneForm from "../features/scenes/SceneForm";
import { IControl } from "../features/controls/types";
import { useTranslation } from "react-i18next";

const newEmptyScene: IScene = {
  id: -1,
  name: "",
  scene_type: "enable_automations",
  is_enabled: true,
  status: "off",
  control_ids: [],
};

export const NewScenePage = () => {
  const { data: controls, isLoading } = useFetchData<IControl[]>("/controls");
  const { t } = useTranslation();
  return (
    <Page title={t("New Scene")} isLoading={isLoading}>
      {controls && <SceneForm scene={newEmptyScene} controls={controls} />}
    </Page>
  );
};

export const EditScenePage = () => {
  const params = useParams();
  const { data: scene, isLoading: isSceneLoading } = useFetchData<IScene>(
    `/scenes/${params.sceneid}`
  );
  const { data: controls, isLoading: isControlsLoading } =
    useFetchData<IControl[]>("/controls");
  return (
    <Page title={scene?.name} isLoading={isSceneLoading || isControlsLoading}>
      {scene && controls && <SceneForm scene={scene} controls={controls} />}
    </Page>
  );
};
